export const AUTH0_CUSTOM_CLAIMS_NAMESPACE = 'https://lesmills.com'
